export default "__VITE_ASSET__tm8U48bF__"